import { makeRequest, CommonRequestOptions } from '../makeRequest';
import type { ImportStatus, LearningStandard } from './@types';

export type ExternalTrainingModule = {
   external_training_moduleid: number;
   external_training_module_importid: number;
   title: string;
   created_at: number;
   rustici_module_version_id: number;
   import_status: ImportStatus;
   learning_standard: LearningStandard;
};

export type GetExternalTrainingModulesCurrentResponse = {
   modules: ExternalTrainingModule[];
   hasMore: boolean;
};

type GetExternalTrainingModulesCurrentOptions = CommonRequestOptions & {
   query?: string;
   order?: 'DESC' | 'ASC';
   offset?: number;
   limit?: number;
};

export async function getExternalTrainingModulesCurrent({
   query,
   order,
   offset,
   limit,
   ...common
}: GetExternalTrainingModulesCurrentOptions = {}): Promise<GetExternalTrainingModulesCurrentResponse> {
   return makeRequest('get', '/external-training-modules/current', {
      ...common,
      query: {
         query,
         order,
         offset,
         limit,
      },
   });
}
